import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import TextField from '@mui/material/TextField'
import { IIncidentReportFormData } from '../IncidentReportModal'
import styles from '../styles.module.css'
import PrimaryDropdown from '../../../../global/components/dropdowns/PrimaryDropdown'
import { fetchData } from '../../../../global/utils/fetch'
import { getCoachUsers } from '../../../api'
import { PERMISSIONS } from '../../../../global/constants/permissions'
import { IUser } from '../../../../../../app/entities/User'

interface IActionPlanTabProps {
  formData: IIncidentReportFormData
  setFormData: Dispatch<SetStateAction<IIncidentReportFormData>>
}

function ActionPlanTab({ formData, setFormData }: IActionPlanTabProps) {
  const [coaches, setCoaches] = useState<IUser[]>([])

  useEffect(() => {
    async function fetchCoaches() {
      try {
        const users = await fetchData<IUser[]>(
          getCoachUsers(PERMISSIONS.AUDITS.ENTRIES.COACHING_ASSIGNEE.NAME),
        )
        setCoaches(users || [])
      } catch (error) {
        console.error('Error fetching coaches:', error)
      }
    }
    fetchCoaches()
  }, [])

  function handleChange(field: keyof IIncidentReportFormData, value: any) {
    setFormData((prev) => ({ ...prev, [field]: value }))
  }

  const coachItems = coaches.map((coach) => ({
    key: coach.objectId,
    value: coach.name,
  }))

  return (
    <div className={styles.formContainer}>
      <div style={{ marginBottom: '16px' }}>
        <PrimaryDropdown
          label='Assign To'
          defaultValue={formData.coachObjectId || ''}
          onChange={(value) => handleChange('coachObjectId', value)}
          items={coachItems}
        />
      </div>
      <TextField
        label='Corrective Action Plan'
        value={formData.correctionActionPlan}
        onChange={(e) => handleChange('correctionActionPlan', e.target.value)}
        multiline
        rows={12}
        fullWidth
      />
    </div>
  )
}

export default ActionPlanTab
